export default "__VITE_PUBLIC_ASSET__0d33a0dc__"